import styled from 'styled-components';

const PeerReviewOptionThead = styled.thead`
  @media (max-width: 767px) {
    display: none;
  }
`;

export default PeerReviewOptionThead;
